/**
 * Helpers for creating DocumentsNotary instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { DocumentNotary } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../../types";
import type { IGetDocumentNotaryparams } from "../DocumentsNotary";
import type { SendResult } from "./documentsNotaryMethodsHelpers";
import {
	createGetMethod,
	createGetByUidMethod,
	createPostMethod,
	createDeleteMethod,
	createSendToRecipientMethod,
} from "./documentsNotaryMethodsHelpers";

export interface DocumentsNotaryInstance {
	get(q: IGetDocumentNotaryparams): Promise<DocumentNotary[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<DocumentNotary>;
	post(body: FormData): Promise<DocumentNotary>;
	delete(uid: string): Promise<void>;
	sendToRecipient(recipientUid: string, folderUid: string, files: File[]): Promise<SendResult>;
}

/**
 * Create DocumentsNotary instance with all methods
 */
export function createDocumentsNotaryInstance(baseNotary: IBaseNotary): DocumentsNotaryInstance {
	const baseUrl = baseNotary.namespaceUrl.concat("/documents_notary");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		post: createPostMethod(baseNotary, baseUrl),
		delete: createDeleteMethod(baseNotary, baseUrl),
		sendToRecipient: createSendToRecipientMethod(baseNotary, baseUrl),
	};
}
